'use client';

import { c as _c } from "react/compiler-runtime";
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import LoaderCircle from '@components/loader-circle/LoaderCircle';
import SVGelem from '@components/SVGelem/SVGelem';
import ROUTES from '@lib/constants/routes';
import { groupByQueue } from '@lib/tools/_group_gallery_by_queue';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from './GallerySliderMobile.module.scss';
import 'swiper/css';
import { GalleryFilterCategories } from '../gallery-filter-categories/GalleryFilterCategories';
import GallerySlideModalInner from '../gallery-slide-modal-inner/GallerySlideModalInner';
SwiperCore.use([FreeMode, Mousewheel]);
const GalleryCategoriesBox = props => {
  const $ = _c(23);
  const {
    queue,
    setQueue,
    groupCategories,
    categories,
    onClick,
    onClose,
    activeSwitch,
    setActiveSwitch
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={style.selector__line} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={style.selector__top__title}>Фильтры</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = () => onClose();
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SVGelem href="#close-white" className={style.buttonCloseIconWhite} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className={style.selector__top}>{t1}<div onClick={t2} role="button" tabIndex="0">{t3}</div></div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== activeSwitch || $[8] !== categories || $[9] !== groupCategories || $[10] !== onClick || $[11] !== queue || $[12] !== setActiveSwitch || $[13] !== setQueue) {
    t5 = <GalleryFilterCategories title={"\u0424\u0438\u043B\u044C\u0442\u0440\u044B"} queue={queue} setQueue={setQueue} groupCategories={groupCategories} categories={categories} onClick={onClick} activeSwitch={activeSwitch} setActiveSwitch={setActiveSwitch} />;
    $[7] = activeSwitch;
    $[8] = categories;
    $[9] = groupCategories;
    $[10] = onClick;
    $[11] = queue;
    $[12] = setActiveSwitch;
    $[13] = setQueue;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div>{t0}{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== onClose) {
    t7 = <button className={style.showBtn} onClick={() => onClose()}>Показать</button>;
    $[18] = onClose;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className={style.selector__content}><div className={style.selector__list}>{t6}{t7}</div></div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
const GallerySliderMobile = t0 => {
  const $ = _c(85);
  const {
    gallery
  } = t0;
  const [swiper, setSwiper] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [categories, setCategories] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [groupCategories, setGroupCategories] = useState(t2);
  const [queue, setQueue] = useState(null);
  const [swiperActive, setSwiperActive] = useState(0);
  const [activeSwitch, setActiveSwitch] = useState(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [sliderArr, setSliderArr] = useState(t3);
  const [selector, setSelector] = useState(false);
  const [currUrl, setCurrUrl] = useState("");
  const [element, setElement] = useState(null);
  const [scale, setScale] = useState(1);
  const [scaleValue, setScaleValue] = useState(1);
  let t4;
  if ($[3] !== element) {
    t4 = element?.getBoundingClientRect().width;
    $[3] = element;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const elScale = t4 / element?.offsetWidth;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      crumbs: [{
        id: 1,
        text: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        link: ROUTES.root
      }, {
        id: 2,
        text: "\u0413\u0430\u043B\u0435\u0440\u0435\u044F"
      }]
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const breadCrumbsApi = t5;
  let t6;
  if ($[6] !== swiper || $[7] !== swiperActive) {
    t6 = () => {
      swiper.slideTo(swiperActive - 1);
    };
    $[6] = swiper;
    $[7] = swiperActive;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handlePrev = t6;
  let t7;
  if ($[9] !== swiper) {
    t7 = () => {
      swiper.slideNext();
    };
    $[9] = swiper;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleNext = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = value => {
      setActiveSwitch(value);
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleSwitch = t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setSelector(false);
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const onCloseFilter = t9;
  swiper?.on("slideChange", () => {
    setSwiperActive(swiper.activeIndex);
  });
  let t10;
  let t11;
  if ($[13] !== sliderArr || $[14] !== swiperActive) {
    t10 = () => {
      const str = sliderArr[swiperActive];
      if (typeof str === "string") {
        setCurrUrl(sliderArr[swiperActive]);
      }
    };
    t11 = [sliderArr, swiperActive];
    $[13] = sliderArr;
    $[14] = swiperActive;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[17] !== element) {
    t12 = () => {
      setScale(element?.getBoundingClientRect().width / element?.offsetWidth);
    };
    t13 = [element];
    $[17] = element;
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  useEffect(t12, t13);
  let t14;
  if ($[20] !== elScale) {
    t14 = () => {
      setScaleValue(elScale);
    };
    $[20] = elScale;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== elScale || $[23] !== scale) {
    t15 = [elScale, scale];
    $[22] = elScale;
    $[23] = scale;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  useEffect(t14, t15);
  let t16;
  let t17;
  if ($[25] !== currUrl) {
    t16 = () => {
      setElement(document.getElementById(currUrl));
    };
    t17 = [currUrl];
    $[25] = currUrl;
    $[26] = t16;
    $[27] = t17;
  } else {
    t16 = $[26];
    t17 = $[27];
  }
  useEffect(t16, t17);
  let t18;
  let t19;
  if ($[28] !== gallery) {
    t18 = () => {
      if (gallery) {
        setActiveSwitch(gallery[0]?.title);
        setQueue(gallery[0]?.queue);
        setGroupCategories(groupByQueue(gallery));
        const uniqueTitles = new Set(gallery.map(_temp));
        setCategories(Array.from(uniqueTitles));
      }
    };
    t19 = [gallery];
    $[28] = gallery;
    $[29] = t18;
    $[30] = t19;
  } else {
    t18 = $[29];
    t19 = $[30];
  }
  useEffect(t18, t19);
  let t20;
  if ($[31] !== activeSwitch || $[32] !== gallery || $[33] !== queue) {
    t20 = () => {
      if (gallery && activeSwitch) {
        const sliderItem = gallery.find(i => i.title === activeSwitch && i.queue === queue);
        if (sliderItem) {
          setSliderArr(sliderItem.absolutePath);
        }
      }
    };
    $[31] = activeSwitch;
    $[32] = gallery;
    $[33] = queue;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== activeSwitch || $[36] !== gallery || $[37] !== queue || $[38] !== sliderArr) {
    t21 = [activeSwitch, gallery, queue, sliderArr];
    $[35] = activeSwitch;
    $[36] = gallery;
    $[37] = queue;
    $[38] = sliderArr;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  useEffect(t20, t21);
  let t22;
  if ($[40] !== swiper) {
    t22 = () => {
      if (swiper) {
        swiper.slideTo(0);
      }
    };
    $[40] = swiper;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== activeSwitch) {
    t23 = [activeSwitch];
    $[42] = activeSwitch;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  useEffect(t22, t23);
  let t24;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className={style.crumbs}><BreadCrumbs item={breadCrumbsApi} /></div>;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== scale || $[46] !== scaleValue || $[47] !== sliderArr) {
    t25 = sliderArr?.map(url => <SwiperSlide key={url} className={style.swiperSlide}><GallerySlideModalInner url={url} scale={scale} setScale={setScale} scaleValue={scaleValue} /></SwiperSlide>);
    $[45] = scale;
    $[46] = scaleValue;
    $[47] = sliderArr;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== sliderArr.length) {
    t26 = sliderArr?.length === 0 && <LoaderCircle someStyles={style.loader} />;
    $[49] = sliderArr.length;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  let t28;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = () => setSelector(_temp2);
    t28 = <span>Фильтры</span>;
    $[51] = t27;
    $[52] = t28;
  } else {
    t27 = $[51];
    t28 = $[52];
  }
  let t29;
  if ($[53] !== selector) {
    t29 = cn(style.selector__arrow, {
      [style.selector__arrow_down]: selector
    });
    $[53] = selector;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <path d="M7.75 7.21238e-07L0.605289 6.75L14.8947 6.75L7.75 7.21238e-07Z" fill="#1C1C1C" />;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t29) {
    t31 = <div className={style.selector}><button className={style.selector__active} onClick={t27}>{t28}<svg className={t29} width="15" height="7" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">{t30}</svg></button></div>;
    $[56] = t29;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.876367 6.49105C0.605168 6.21985 0.605168 5.78015 0.876367 5.50895L5.29578 1.08954C5.56698 0.81834 6.00668 0.81834 6.27788 1.08954C6.54907 1.36073 6.54907 1.80043 6.27788 2.07163L2.34951 6L6.27788 9.92837C6.54907 10.1996 6.54907 10.6393 6.27788 10.9105C6.00668 11.1817 5.56698 11.1817 5.29578 10.9105L0.876367 6.49105ZM14.9443 6.69444L1.36741 6.69445L1.36741 5.30556L14.9443 5.30556L14.9443 6.69444Z" fill="#1C1C1C" /></svg>;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== handlePrev) {
    t33 = <div className="swiper-button-prev gallery_swiper_mobile__prev" onClick={handlePrev} role="button" tabIndex="0">{t32}</div>;
    $[59] = handlePrev;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  const t34 = swiperActive + 1;
  let t35;
  if ($[61] !== sliderArr.length || $[62] !== t34) {
    t35 = <div className={style.nav__counter}>{t34}/{sliderArr.length}</div>;
    $[61] = sliderArr.length;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1236 6.49105C14.3948 6.21985 14.3948 5.78015 14.1236 5.50895L9.70422 1.08954C9.43302 0.81834 8.99332 0.81834 8.72212 1.08954C8.45093 1.36073 8.45093 1.80043 8.72212 2.07163L12.6505 6L8.72212 9.92837C8.45093 10.1996 8.45093 10.6393 8.72212 10.9105C8.99332 11.1817 9.43302 11.1817 9.70422 10.9105L14.1236 6.49105ZM0.055664 6.69444L13.6326 6.69445L13.6326 5.30556L0.0556641 5.30556L0.055664 6.69444Z" fill="#1C1C1C" /></svg>;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] !== handleNext) {
    t37 = <div className="swiper-button-next gallery_swiper_mobile__next" onClick={handleNext} role="button" tabIndex="0">{t36}</div>;
    $[65] = handleNext;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] !== t33 || $[68] !== t35 || $[69] !== t37) {
    t38 = <div className={style.nav__wrapper}>{t33}{t35}{t37}</div>;
    $[67] = t33;
    $[68] = t35;
    $[69] = t37;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t31 || $[72] !== t38) {
    t39 = <div className={style.nav}>{t31}{t38}</div>;
    $[71] = t31;
    $[72] = t38;
    $[73] = t39;
  } else {
    t39 = $[73];
  }
  let t40;
  if ($[74] !== activeSwitch || $[75] !== categories || $[76] !== groupCategories || $[77] !== queue || $[78] !== selector) {
    t40 = selector && <GalleryCategoriesBox queue={queue} setQueue={setQueue} groupCategories={groupCategories} categories={categories} oClick={val => handleSwitch(val)} onClose={onCloseFilter} activeSwitch={activeSwitch} setActiveSwitch={setActiveSwitch} />;
    $[74] = activeSwitch;
    $[75] = categories;
    $[76] = groupCategories;
    $[77] = queue;
    $[78] = selector;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== t25 || $[81] !== t26 || $[82] !== t39 || $[83] !== t40) {
    t41 = <><div className={style.content}>{t24}<Swiper onSwiper={setSwiper} slidesPerView={1} allowTouchMove={true} className={`gallery_swiper_mobile ${style.swiper}`}>{t25}{t26}{t39}{t40}</Swiper></div></>;
    $[80] = t25;
    $[81] = t26;
    $[82] = t39;
    $[83] = t40;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  return t41;
};
export default GallerySliderMobile;
function _temp(item) {
  return item.title;
}
function _temp2(prev) {
  return !prev;
}